import { render, staticRenderFns } from "./PayrollCard.vue?vue&type=template&id=4c86c691&"
import script from "./PayrollCard.vue?vue&type=script&lang=js&"
export * from "./PayrollCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports